// extracted by mini-css-extract-plugin
export var callCard = "_os-0";
export var callMessageButton = "_os-1";
export var helpIcon = "_os-3";
export var helpIconContainer = "_os-4";
export var verticalDivider = "_os-2";